import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './translations/en.json';
import no from './translations/no.json';
import es from './translations/es.json';
import ru from './translations/ru.json';
import be from './translations/be.json';

export const languagesOption = [
	{ value: 'en', label: 'EN' },
	{ value: 'no', label: 'NO' },
	{ value: 'es', label: 'ES'},
	{ value: 'ru', label: 'RU'},
	{ value: 'be', label: 'BY'},
];

export const STORE_LANGUAGE_KEY = "wondr.settings.lang";

const languageDetectorPlugin: any = {
	type: "languageDetector",
	async: true,
	init: () => { },
	detect: async function (callback: (lang: string) => void) {
		try {
			const storageLng = localStorage.getItem(STORE_LANGUAGE_KEY);
			if (storageLng) {
				return callback(storageLng);
			} else {
				const browserLanguage = navigator.language.split('-')[0];
				const supportedLanguages = languagesOption.map(lang => lang.value);
				const defaultLanguage = supportedLanguages.includes(browserLanguage)
					? browserLanguage
					: 'no';
				return callback(defaultLanguage);
			}
			
		} catch (error) {
			console.log("Error reading language", error);
			return callback('no');
		}
	},
	cacheUserLanguage: async function (language: string) {
		try {
			console.log("Storing language: ", language);
			localStorage.setItem(STORE_LANGUAGE_KEY, language);
		} catch (error) { }
	},
};

const resources = {
	en: {
		translation: en,
	},
	no: {
		translation: no,
	},
	es: {
		translation: es,
	},
	ru: {
		translation: ru,
	},
	be: {
		translation: be,
	},
};

const getLastKeyPart = (key: string) => {
	const parts = key.split('.');
	return parts[parts.length - 1];
};

i18n
	.use(languageDetectorPlugin)
	.use(initReactI18next)
   .init({
		resources,
		compatibilityJSON: 'v4',
		fallbackLng: 'no',
		// fallbackLng: deviceLanguage.split("_")[0] && deviceLanguage.split("_")[0],
		interpolation: {
			escapeValue: false,
		},
		detection: {
			order: ['localStorage', 'navigator'],
			caches: ['localStorage'],
		},
		parseMissingKeyHandler: (key) => {
			const lastKeyPart = getLastKeyPart(key);
			return i18n.exists(lastKeyPart) ? i18n.t(lastKeyPart) : lastKeyPart;
		},
	})
	.then((r: any) => console.log("i18n initialized: ", r))
	     .catch((error) => {
		console.error('Error initializing i18n:', error);
	});

export default i18n;